import api from './api';

const dimensionService = {
  // Dimensions CRUD
  getAll: () => api.get('/financialdimensions'),
  get: (id: number) => api.get(`/financialdimensions/${id}`),
  create: (data: any) => api.post('/financialdimensions', data),
  update: (id: number, data: any) => api.put(`/financialdimensions/${id}`, data),
  delete: (id: number) => api.delete(`/financialdimensions/${id}`),

  // Values
  createValue: (dimId: number, data: any) => api.post(`/financialdimensions/${dimId}/values`, data),
  updateValue: (valueId: number, data: any) => api.put(`/financialdimensions/values/${valueId}`, data),
  deleteValue: (valueId: number) => api.delete(`/financialdimensions/values/${valueId}`),

  // Document dimensions
  getDocumentDimensions: (entityType: string, entityId: number) =>
    api.get(`/financialdimensions/document/${entityType}/${entityId}`),
  saveDocumentDimensions: (entityType: string, entityId: number, dims: { dimensionId: number; dimensionValueId: number }[]) =>
    api.post(`/financialdimensions/document/${entityType}/${entityId}`, dims),
  copyDimensions: (srcType: string, srcId: number, tgtType: string, tgtId: number) =>
    api.post(`/financialdimensions/copy/${srcType}/${srcId}/to/${tgtType}/${tgtId}`),
};

export default dimensionService;
